export const DOMAIN = 'auth';
